import { WORKSPACES } from "../contexts/Workspacecontext";
import { RECRUITMENT, CONSULTANCY } from "./moduleAccess";

export const COMPANY_MENU = [
  {
    name: "Dashboard",
    icon: "material-symbols-light:dashboard-outline",
    to: "/dashboard",
    roles: ["ROLE_RECRUITER-HR", "ROLE_MANAGER", "ROLE_HOD", "ROLE_EMPLOYEE"],
    moduleCodes: [RECRUITMENT.DASHBOARD],
  },
  {
    name: "Vacancies",
    icon: "fluent-mdl2:recruitment-management",
    to: "/recruitment/vacancies",
    roles: ["ROLE_RECRUITER-HR", "ROLE_MANAGER", "ROLE_HOD"],
    moduleCodes: [
      RECRUITMENT.VACANCIES_ALL,
      RECRUITMENT.VACANCIES_CREATE,
      RECRUITMENT.VACANCIES_PENDING_APPROVALS,
      RECRUITMENT.VACANCIES_APPROVED,
    ],
    submenu: [
      {
        name: "All Vacancies",
        to: "/recruitment/vacancies/all",
        roles: ["ROLE_RECRUITER-HR", "ROLE_HOD"],
        moduleCodes: [RECRUITMENT.VACANCIES_ALL],
      },
      {
        name: "Create Vacancy",
        to: "/recruitment/vacancies/create",
        roles: ["ROLE_MANAGER"],
        moduleCodes: [RECRUITMENT.VACANCIES_CREATE],
      },
      {
        name: "Pending Approvals",
        to: "/recruitment/vacancies/approvals",
        roles: ["ROLE_HOD", "ROLE_RECRUITER-HR"],
        moduleCodes: [RECRUITMENT.VACANCIES_PENDING_APPROVALS],
      },
      {
        name: "Approved Vacancies",
        to: "/recruitment/vacancies/approved",
        roles: ["ROLE_RECRUITER-HR"],
        moduleCodes: [RECRUITMENT.VACANCIES_APPROVED],
      },
    ],
  },
  {
    name: "Job Posts",
    icon: "mdi:briefcase-outline",
    to: "/recruitment/job-posts",
    roles: ["ROLE_RECRUITER-HR"],
    moduleCodes: [
      RECRUITMENT.JOB_POSTS_ALL,
      RECRUITMENT.JOB_POSTS_PLATFORMS,
      RECRUITMENT.JOB_POSTS_CREATE,
    ],
    submenu: [
      {
        name: "All Job Posts",
        to: "/recruitment/job-posts/all",
        roles: ["ROLE_RECRUITER-HR"],
        moduleCodes: [RECRUITMENT.JOB_POSTS_ALL],
      },
      {
        name: "Internal Posts",
        to: "/recruitment/job-posts/internal",
        roles: ["ROLE_RECRUITER-HR"],
        moduleCodes: [RECRUITMENT.JOB_POSTS_PLATFORMS],
      },
      {
        name: "Create Job Post",
        to: "/recruitment/job-posts/create",
        roles: ["ROLE_RECRUITER-HR"],
        moduleCodes: [RECRUITMENT.JOB_POSTS_CREATE],
      },
    ],
  },
  {
    name: "Candidates",
    icon: "tabler:users-group",
    to: "/recruitment/candidates",
    roles: ["ROLE_RECRUITER-HR", "ROLE_EMPLOYEE", "ROLE_CONSULTANT"],
    moduleCodes: [
      RECRUITMENT.CANDIDATES_ALL,
      RECRUITMENT.CANDIDATES_APPLIED,
      RECRUITMENT.CANDIDATES_ADD,
    ],
    submenu: [
      {
        name: "All Candidates",
        to: "/recruitment/candidates/all",
        roles: ["ROLE_RECRUITER-HR"],
        moduleCodes: [RECRUITMENT.CANDIDATES_ALL],
      },
      {
        name: "Applied Candidates",
        to: "/recruitment/candidates/applied",
        roles: ["ROLE_RECRUITER-HR"],
        moduleCodes: [RECRUITMENT.CANDIDATES_APPLIED],
      },
      {
        name: "Add Candidate",
        to: "/recruitment/candidates/create",
        roles: ["ROLE_RECRUITER-HR"],
        moduleCodes: [RECRUITMENT.CANDIDATES_ADD],
      },
    ],
  },
  {
    name: "Interviews",
    icon: "fluent:person-chat-24-regular",
    to: "/recruitment/interviews",
    roles: ["ROLE_RECRUITER-HR"],
    moduleCodes: [
      RECRUITMENT.INTERVIEWS_PIPELINE,
      RECRUITMENT.INTERVIEWS_SCHEDULE,
      RECRUITMENT.INTERVIEWS_UPDATE_STATUS,
    ],
    submenu: [
      {
        name: "Interview Pipeline",
        to: "/recruitment/interviews/pipeline",
        roles: ["ROLE_RECRUITER-HR"],
        moduleCodes: [RECRUITMENT.INTERVIEWS_PIPELINE],
      },
      {
        name: "Schedule Interview",
        to: "/recruitment/interviews/schedule",
        roles: ["ROLE_RECRUITER-HR"],
        moduleCodes: [RECRUITMENT.INTERVIEWS_SCHEDULE],
      },
      {
        name: "Update Status",
        to: "/recruitment/interviews/update-status",
        roles: ["ROLE_RECRUITER-HR"],
        moduleCodes: [RECRUITMENT.INTERVIEWS_UPDATE_STATUS],
      },
    ],
  },
  {
    name: "Hiring Flow",
    icon: "mdi:sitemap-outline",
    to: "/recruitment/hiring-flow",
    roles: ["ROLE_RECRUITER-HR"],
    moduleCodes: [RECRUITMENT.HIRING_FLOW_ALL, RECRUITMENT.HIRING_FLOW_CREATE],
    submenu: [
      {
        name: "All Hiring Flows",
        to: "/recruitment/hiring-flow/all",
        roles: ["ROLE_RECRUITER-HR"],
        moduleCodes: [RECRUITMENT.HIRING_FLOW_ALL],
      },
      {
        name: "Create Hiring Flow",
        to: "/recruitment/hiring-flow/create",
        roles: ["ROLE_RECRUITER-HR"],
        moduleCodes: [RECRUITMENT.HIRING_FLOW_CREATE],
      },
    ],
  },
  {
    name: "Job Drives",
    icon: "mdi:calendar-star-outline",
    to: "/recruitment/job-drives",
    roles: ["ROLE_RECRUITER-HR"],
    moduleCodes: [RECRUITMENT.JOB_DRIVES_ALL, RECRUITMENT.JOB_DRIVES_CREATE],
    submenu: [
      {
        name: "All Drives",
        to: "/recruitment/job-drives/all",
        roles: ["ROLE_RECRUITER-HR"],
        moduleCodes: [RECRUITMENT.JOB_DRIVES_ALL],
      },
      {
        name: "Create Drive",
        to: "/recruitment/job-drives/create",
        roles: ["ROLE_RECRUITER-HR"],
        moduleCodes: [RECRUITMENT.JOB_DRIVES_CREATE],
      },
    ],
  },
  {
    name: "Connections",
    icon: "mdi:handshake-outline",
    to: "/recruitment/connections",
    roles: ["ROLE_RECRUITER-HR"],
    moduleCodes: [
      RECRUITMENT.CONNECTIONS,
      RECRUITMENT.CONNECTIONS_SHARE_REQUIREMENT,
      RECRUITMENT.CONNECTIONS_JOB_POSTS,
    ],
    submenu: [
      {
        name: "Candidates",
        to: "/recruitment/connections/candidates",
        roles: ["ROLE_RECRUITER-HR"],
        moduleCodes: [RECRUITMENT.CONNECTIONS],
      },
      {
        name: "Share Requirement",
        to: "/recruitment/connections/share",
        roles: ["ROLE_RECRUITER-HR"],
        moduleCodes: [RECRUITMENT.CONNECTIONS_SHARE_REQUIREMENT],
      },
      {
        name: "Job Posts",
        to: "/recruitment/connections/job-posts",
        roles: ["ROLE_RECRUITER-HR"],
        moduleCodes: [RECRUITMENT.CONNECTIONS_JOB_POSTS],
      },
    ],
  },
];

export const CONSULTANT_MENU = [
  {
    name: "Dashboard",
    icon: "material-symbols-light:dashboard-outline",
    to: "/dashboard",
    roles: ["ROLE_CONSULTANT", "ROLE_CONSULTANT-ADMIN"],
    moduleCodes: [CONSULTANCY.DASHBOARD],
  },
  {
    name: "Company Requirement",
    icon: "mdi:file-document-outline",
    to: "/consultant/candidate-requirement",
    roles: ["ROLE_CONSULTANT"],
    moduleCodes: [CONSULTANCY.CANDIDATE_REQUIREMENT],
  },
  {
    name: "Job Posts",
    icon: "mdi:briefcase-outline",
    to: "/consultant/job-posts",
    roles: ["ROLE_CONSULTANT"],
    moduleCodes: [CONSULTANCY.JOB_POSTS_ALL, CONSULTANCY.JOB_POSTS_CREATE],
    submenu: [
      {
        name: "All Job Posts",
        to: "/consultant/job-posts/all",
        roles: ["ROLE_CONSULTANT"],
        moduleCodes: [CONSULTANCY.JOB_POSTS_ALL],
      },
      {
        name: "Create Job Post",
        to: "/consultant/job-posts/create",
        roles: ["ROLE_CONSULTANT"],
        moduleCodes: [CONSULTANCY.JOB_POSTS_CREATE],
      },
    ],
  },
  {
    name: "Job Drives",
    icon: "mdi:calendar-star-outline",
    to: "/consultant/job-drives",
    roles: ["ROLE_CONSULTANT"],
    moduleCodes: [CONSULTANCY.JOB_DRIVES_ALL, CONSULTANCY.JOB_DRIVES_CREATE],
    submenu: [
      {
        name: "All Drives",
        to: "/consultant/job-drives/all",
        roles: ["ROLE_CONSULTANT"],
        moduleCodes: [CONSULTANCY.JOB_DRIVES_ALL],
      },
      {
        name: "Create Drive",
        to: "/consultant/job-drives/create",
        roles: ["ROLE_CONSULTANT"],
        moduleCodes: [CONSULTANCY.JOB_DRIVES_CREATE],
      },
    ],
  },
  {
    name: "Candidates",
    icon: "tabler:users-group",
    to: "/consultant/candidates",
    roles: ["ROLE_CONSULTANT", "ROLE_CONSULTANT-ADMIN"],
    moduleCodes: [CONSULTANCY.CANDIDATES_ALL, CONSULTANCY.CANDIDATES_ADD],
    submenu: [
      {
        name: "All Candidates",
        to: "/consultant/candidates/all",
        roles: ["ROLE_CONSULTANT", "ROLE_CONSULTANT-ADMIN"],
        moduleCodes: [CONSULTANCY.CANDIDATES_ALL],
      },
      {
        name: "Add Candidate",
        to: "/consultant/candidates/create",
        roles: ["ROLE_CONSULTANT", "ROLE_CONSULTANT-ADMIN"],
        moduleCodes: [CONSULTANCY.CANDIDATES_ADD],
      },
    ],
  },
  {
    name: "Share Candidates",
    icon: "mdi:share-variant-outline",
    to: "/consultant/share-candidates",
    roles: ["ROLE_CONSULTANT"],
    moduleCodes: [CONSULTANCY.SHARE_CANDIDATES],
  },
  {
    name: "Connections",
    icon: "mdi:handshake-outline",
    to: "/consultant/connections",
    roles: ["ROLE_CONSULTANT-ADMIN"],
    moduleCodes: [CONSULTANCY.CONNECTIONS],
  },
];

export const getNavigationByWorkspace = (workspace) =>
  workspace === WORKSPACES.COMPANY ? COMPANY_MENU : CONSULTANT_MENU;

// Role-based visibility filter — unchanged.
// If a role doesn't match, the menu item (and submenu) is hidden entirely.
export const filterMenuByRoles = (items = [], userRoles = []) =>
  items
    .filter((item) => item.roles?.some((role) => userRoles.includes(role)))
    .map((item) => ({
      ...item,
      submenu: filterMenuByRoles(item.submenu, userRoles),
    }));

export const isMenuItemActive = (item, pathname) => {
  if (pathname === item.to || pathname.startsWith(`${item.to}/`)) {
    return true;
  }

  return (item.submenu || []).some((subItem) =>
    isMenuItemActive(subItem, pathname),
  );
};
